<template>
	<v-card style="width:100%; height: 600px; width:550px;">
		<v-flex xs12 class="text-xs-center" style="padding-top:10px;">
			<h3>Choose a Client</h3>
		</v-flex>

		<v-card-text>
			<v-flex xs12>
				<v-text-field ref="clientSearch" v-debounce:300ms="updateSearch" append-icon="search" label="Search" autofocus="" background-color="#fff"></v-text-field>
				<v-data-table disable-initial-sort :headers="headers" :items="tenants" :search="search" :pagination.sync="pagination">
					<template slot="items" slot-scope="props">
						<tr>
							<td class="text-xs-left">
								<a href="#" @click.prevent.stop="onSelectTenant(props.item)">
									<v-img :src="props.item.logoUrl" alt="logo" :width="150" :height="50" contain style="margin-top:5px; margin-bottom:5px;"></v-img>
								</a>
							</td>
							<td class="text-xs-left"><a href="#" @click.prevent.stop="onSelectTenant(props.item)">{{ props.item.name }}</a></td>
							<td>
								<v-tooltip bottom>
									<template v-slot:activator="{ on }">
										<v-btn color="primary" flat icon v-on="on" @click="onSelectTenant(props.item)"><v-icon>launch</v-icon></v-btn>
									</template>
									<span>Open Client</span>
								</v-tooltip>
								
							</td>
						</tr>
					</template>
				</v-data-table>
			</v-flex>
		</v-card-text>

		<v-divider></v-divider>
	</v-card>
</template>

<script>
	export default {
		props: {
			tenants: {
				required: true
			}
		},
		data() {
			return {
				items: [],
				search: '',
				headers: [
					{
						text: '',
						align: 'left',
						sortable: false,
						value: 'photoUrl',
						width: 1
					},
					{ text: 'Client Name', value: 'name' },
					{ text: '', value: 'actions', sortable: false, width: 1},
				],
				pagination: {
					sortBy: 'name',
					rowsPerPage: 5
				},
			};
		},
		mounted() {
			this.$nextTick(() => {
                this.$refs.clientSearch.focus();
            });
		},
		methods: {
			onSelectTenant(tenant) {
				this.$emit('onSelectTenant', { tenant: tenant, viaSelector: false });
			},
			updateSearch(val) {
				this.search = val;
			}
		}
	};
</script>
